import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { "data-interface-section": "header-category-page" }

import Typography from '@/components_new/Typography.vue'
import Button from '@/components_new/Button.vue'
import { CategoryInfo } from '@/types'


export default /*@__PURE__*/_defineComponent({
  __name: 'CategoryHeader',
  props: {
    category: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Typography, {
      is: "h1",
      size: "s"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(props.category?.fullTitle), 1)
      ]),
      _: 1
    }),
    (_ctx.category?.subCategories?.length)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: _normalizeClass(_ctx.$style.subCategories)
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.category.subCategories, (subCategory) => {
            return (_openBlock(), _createElementBlock("li", {
              key: subCategory.id
            }, [
              _createVNode(Button, {
                interfaceTarget: "category",
                size: "s",
                to: subCategory.href,
                color: "carbon-400"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(subCategory.title), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})